webpackJsonp([77],{

/***/ 1164:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(true);
// imports


// module
exports.push([module.i, ".Table1 .table{display:table;border-collapse:collapse;width:100%}.Table1 .td,.Table1 .th{border:1px solid #999;text-align:center;font-size:1em;font-weight:400}.Table1 a{text-decoration:underline}", "", {"version":3,"sources":["/Users/yuki/Public/wp-admin/src/components/contents/Table1/src/components/contents/Table1/Table1.s.scss"],"names":[],"mappings":"AAEA,eAEI,cAAc,AACd,yBAAyB,AACzB,UAAW,CACZ,AALH,wBAQI,sBAAsB,AACtB,kBAAkB,AAClB,cAAc,AACd,eAAmB,CACpB,AAZH,UAcI,yBAA0B,CAC3B","file":"Table1.s.scss","sourcesContent":["@import '~scss/variables';\n\n.Table1 {\n  .table {\n    display: table;\n    border-collapse: collapse;\n    width: 100%;\n  }\n  .th,\n  .td {\n    border: 1px solid #999;\n    text-align: center;\n    font-size: 1em;\n    font-weight: normal;\n  }\n  a {\n    text-decoration: underline;\n  }\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 422:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1164);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(342)("88c5adb6", content, true, {});

/***/ })

});


// WEBPACK FOOTER //
// static/js/77.7b25cc5fbecb020df188.js